import clsx from "clsx";

export const AdminPip = ({
    children,
    colour,
    blank,
}: {
    children: React.ReactNode;
    colour: string;
    blank?: boolean;
}) => (
    <span
        className={clsx(
            " text-neutral-900",
            colour,
            blank ? "!bg-transparent" : "rounded-lg px-1 py-0.5",
        )}
        style={{
            fontSize: "10px",
        }}
    >
        {children}
    </span>
);
